import { render, staticRenderFns } from "./SamplingOrderOverview.vue?vue&type=template&id=223129db&scoped=true&lang=html&"
import script from "./SamplingOrderOverview.vue?vue&type=script&lang=js&"
export * from "./SamplingOrderOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223129db",
  null
  
)

export default component.exports